<template>
  <SeoPage page-key="sviluppoSitiInternetTicino" />
</template>

<script setup>
import SeoPage from '../components/SeoPage.vue'

defineOptions({
  name: 'SviluppoSitiInternetTicinoPage'
})
</script>

